import logo from "./mgames.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>MGames have moved to a new address.</p>
        <a className="App-link" href="https://mgames-95701.web.app/">
          Click here!
        </a>
      </header>
    </div>
  );
}

export default App;
